import { Link } from "react-router-dom";
import { MapPin, User, CalendarClock, AlertCircle } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { STAGE_META, PROPERTY_TYPE_LABELS, fmtPrice, stagePct } from "@/lib/realestateConstants";

export const PropertyCard = ({ property: p, workspaceId }) => {
  const meta = STAGE_META[p.stage];
  const prog = p.progress?.[p.stage];
  const pct = p.stage === "vendido" ? 100 : stagePct(prog);
  const missing = p.stage === "vendido" ? 0 : (prog?.missing?.length || 0);
  return (
    <Link to={`/space/${workspaceId}/realestate/${p.id}`} data-testid={`property-card-${p.id}`}>
      <Card className="p-4 space-y-3 hover:border-primary/50 hover:-translate-y-0.5 transition-all">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="text-[11px] font-mono text-muted-foreground">{p.ref}</p>
            <h3 className="font-semibold text-sm leading-tight truncate">{p.title}</h3>
          </div>
          <Badge variant="secondary" className="shrink-0 text-[10px]">{PROPERTY_TYPE_LABELS[p.property_type] || p.property_type}</Badge>
        </div>
        {(p.address || p.city) && (
          <p className="text-xs text-muted-foreground flex items-center gap-1 truncate">
            <MapPin size={12} /> {[p.address, p.city].filter(Boolean).join(", ")}
          </p>
        )}
        <div className="flex items-center justify-between text-xs">
          <span className="font-semibold">{fmtPrice(p.price)}</span>
          {p.seller?.name && <span className="text-muted-foreground flex items-center gap-1 truncate"><User size={12} /> {p.seller.name}</span>}
        </div>
        <div className="space-y-1">
          <div className="flex items-center justify-between text-[11px] text-muted-foreground">
            <span className={meta.text + " font-semibold"}>{meta.label}</span>
            <span>{pct}%</span>
          </div>
          <Progress value={pct} className="h-1.5" />
        </div>
        <div className="flex items-center gap-3 text-[11px] text-muted-foreground">
          {missing > 0 ? (
            <span className="flex items-center gap-1 text-amber-600" data-testid={`property-missing-${p.id}`}><AlertCircle size={12} /> {missing} pendientes</span>
          ) : (
            <span className="text-emerald-600">Etapa completa</span>
          )}
          {p.visits_count > 0 && <span className="flex items-center gap-1"><CalendarClock size={12} /> {p.visits_count} visitas</span>}
        </div>
      </Card>
    </Link>
  );
};
